import React from "react"
import { useSelector } from "react-redux"

import AddressCard from "./addressCard"


const ShippingAddressCards = (props) => {

    const { shippingAddresses, selectedAddressId, handleShippingAddress, showAddShipAddr, setVisibleAddNewShippingAddr, disabled } = props
    const states = useSelector((state) => state.common.states)

    const handleAddressSelection = (id) => {
        handleShippingAddress(id)
    }

    let updatedShipAddresses = shippingAddresses.map(eachShipAddr => {
        const stateDetails = states.find(eachState => eachState.stateId === eachShipAddr.stateId)
        return {...eachShipAddr, stateName: stateDetails?.stateName}
    })

    updatedShipAddresses.sort((a, b) => {
        const stateComparison = a.stateName?.localeCompare(b.stateName)
    
        if (stateComparison === 0) {
          return a?.city?.localeCompare(b?.city)
        }
      
        return stateComparison
    })
      
    const selectedShipAddress = updatedShipAddresses?.find(eachAddress => eachAddress.shipAddrId === selectedAddressId)

    // console.log('updatedShipAddresses', updatedShipAddresses, selectedAddressId)
    return(
        <div className='post-req-shipping-component' >
            {selectedShipAddress ?
                <AddressCard id={null} address={selectedShipAddress?.shipAddr} city={selectedShipAddress?.city} stateName={selectedShipAddress.stateName} pinCode={selectedShipAddress.pinCode} buttonLabel={"UNSELECT"} handleAddressSelection={handleAddressSelection} className="selected-btn" disabled={disabled}/>
                :
                <>
                    {updatedShipAddresses?.map(eachAddress => (
                            <AddressCard key={`shippingAddress-${eachAddress.shipAddrId}`} id={eachAddress.shipAddrId} address={eachAddress.shipAddr} city={eachAddress.city} stateName={eachAddress.stateName} pinCode={eachAddress.pinCode} buttonLabel={"SELECT"} handleAddressSelection={handleAddressSelection} disabled={disabled}  />
                        )
                    )}
                    { showAddShipAddr &&
                        <div className='shipping-component' style={{cursor: "pointer"}} onClick={() => {setVisibleAddNewShippingAddr(true)}} >
                            <div className='shipping-address' style={{marginBottom: "10px"}}>
                                <div className='shipping-address-item align-items-stretch'>
                                    <div className='shipping-address-card-details flex flex-column justify-content-center align-items-center w-15rem  border-round-md ml-2'>
                                        <i className='pi pi-plus text-5xl'></i>
                                        <p className='text-lg'>Add New Shipping Address</p>
                                    </div>
                                </div>
                            </div>  
                        </div>
                    }
                </>
            }
        </div>
    )
}

export default ShippingAddressCards